document.addEventListener('DOMContentLoaded', async function () {
  var blocks = document.querySelectorAll('[data-offer-by-country]');
  if (!blocks.length) return;

  var EU_COUNTRIES = [
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'DE', 'FR', 'GR',
    'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK',
    'SI', 'ES', 'SE'
  ];

  function mapCountryToMarket(countryCode) {
    var code = String(countryCode || '').toUpperCase();

    if (code === 'US') return 'US';
    if (code === 'CA') return 'CA';
    if (code === 'GB' || code === 'UK') return 'UK';
    if (code === 'AU') return 'AU';
    if (code === 'NZ') return 'NZ';
    if (code === 'SG') return 'SG';
    if (code === 'DE') return 'DE';
    if (code === 'FR') return 'FR';
    if (EU_COUNTRIES.indexOf(code) !== -1) return 'EU';

    return 'ROW';
  }

  function hasMarketContent(market) {
    return !!(market && market.valid && market.text);
  }

  function firstAvailableMarket(markets) {
    var order = ['WORLD', 'ROW', 'AU', 'US', 'UK', 'CA', 'NZ', 'SG', 'EU', 'DE', 'FR'];

    for (var i = 0; i < order.length; i++) {
      var key = order[i];
      if (hasMarketContent(markets[key])) {
        return markets[key];
      }
    }

    return null;
  }

  function pickMarket(markets, marketKey) {
    if (hasMarketContent(markets.WORLD)) {
      return markets.WORLD;
    }

    if (hasMarketContent(markets[marketKey])) {
      return markets[marketKey];
    }

    if (marketKey === 'ROW' && hasMarketContent(markets.ROW)) {
      return markets.ROW;
    }

    return null;
  }

  function getDisplayedMarketKey(markets, marketKey) {
    if (hasMarketContent(markets.WORLD)) {
      return 'WORLD';
    }

    if (hasMarketContent(markets[marketKey])) {
      return marketKey;
    }

    if (marketKey === 'ROW' && hasMarketContent(markets.ROW)) {
      return 'ROW';
    }

    return '';
  }

  function applyOffer(block, marketData, displayedMarketKey) {
    if (!marketData) {
      block.style.display = 'none';
      block.classList.remove('product-info-gwp-offer--pending');
      return;
    }

    var textEl = block.querySelector('.product-info-gwp-offer__text');
    var rightEl = block.querySelector('.product-info-gwp-offer__right');
    var imageEl = block.querySelector('.product-info-gwp-offer__image');

    block.style.display = '';
    block.setAttribute('data-offer-market', displayedMarketKey || '');
    block.setAttribute('data-offer-text', marketData.text || '');
    block.setAttribute('data-offer-description', marketData.description || '');
    block.setAttribute('data-offer-url', marketData.url || '');

    if (textEl && marketData.text) {
      textEl.textContent = marketData.text;
    }

    var textWrapEl = block.querySelector('.product-info-gwp-offer__text-wrap');
    var descriptionEl = block.querySelector('.product-info-gwp-offer__description');

    if (textWrapEl) {
      if (marketData.description) {
        textWrapEl.classList.remove('product-info-gwp-offer__text-wrap--single');
      } else {
        textWrapEl.classList.add('product-info-gwp-offer__text-wrap--single');
      }
    }

    if (marketData.description) {
      if (!descriptionEl && textWrapEl) {
        descriptionEl = document.createElement('span');
        descriptionEl.className = 'product-info-gwp-offer__description';
        textWrapEl.appendChild(descriptionEl);
      }
      if (descriptionEl) {
        descriptionEl.textContent = marketData.description;
        descriptionEl.style.display = 'block';
      }
    } else if (descriptionEl) {
      descriptionEl.textContent = '';
      descriptionEl.style.display = 'none';
    }

    if (marketData.url) {
      block.setAttribute('href', marketData.url);
      block.removeAttribute('aria-disabled');
    } else {
      block.setAttribute('href', '#');
      block.setAttribute('aria-disabled', 'true');
    }

    if (marketData.url && marketData.image) {
      if (!imageEl && rightEl) {
        imageEl = document.createElement('img');
        imageEl.className = 'product-info-gwp-offer__image';
        rightEl.appendChild(imageEl);
      }

      if (imageEl) {
        imageEl.src = marketData.image;
        imageEl.alt = marketData.text || '';
      }

      if (rightEl) {
        rightEl.classList.remove('hidden');
        rightEl.style.display = 'flex';
      }
    } else {
      if (rightEl) {
        rightEl.classList.add('hidden');
        rightEl.style.display = 'none';
      }
      if (imageEl) {
        imageEl.removeAttribute('src');
        imageEl.removeAttribute('srcset');
        imageEl.alt = '';
      }
    }

    if (!block.dataset.offerClickTracked) {
      block.addEventListener('click', function () {
        var eventPayload = {
          offer_market: block.getAttribute('data-offer-market') || '',
          offer_text: block.getAttribute('data-offer-text') || '',
          offer_description: block.getAttribute('data-offer-description') || '',
          offer_url: block.getAttribute('data-offer-url') || '',
          product_page: window.location.pathname
        };

        if (typeof window.gtag === 'function') {
          window.gtag('event', 'offer_block_click', eventPayload);
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'offer_block_click',
          offer_market: eventPayload.offer_market,
          offer_text: eventPayload.offer_text,
          offer_description: eventPayload.offer_description,
          offer_url: eventPayload.offer_url,
          product_page: eventPayload.product_page
        });
      });

      block.dataset.offerClickTracked = 'true';
    }

    block.classList.remove('product-info-gwp-offer--pending');
  }

  async function getCountryFromIpWhoIs() {
    try {
      var response = await fetch('https://ipwho.is/?fields=country_code', {
        method: 'GET',
        cache: 'no-store'
      });

      if (!response.ok) return '';

      var data = await response.json();
      if (data && data.country_code) {
        return String(data.country_code).toUpperCase();
      }
    } catch (error) {
      console.warn('ipwho.is lookup failed:', error);
    }

    return '';
  }

  async function getCountryFromIpApi() {
    try {
      var response = await fetch('https://ipapi.co/json/', {
        method: 'GET',
        cache: 'no-store'
      });

      if (!response.ok) return '';

      var data = await response.json();
      if (data && data.country_code) {
        return String(data.country_code).toUpperCase();
      }
    } catch (error) {
      console.warn('ipapi lookup failed:', error);
    }

    return '';
  }

  function getCountryFromShopifySelector() {
    var selectors = [
      'form[action*="/localization"] [name="country_code"]',
      'select[name="country_code"]',
      'input[name="country_code"]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (!el) continue;

      var value = '';
      if (el.tagName === 'SELECT') {
        value = el.value || '';
      } else {
        value = el.value || '';
      }

      if (value) {
        return String(value).toUpperCase();
      }
    }

    return '';
  }

  async function getBestCountryCode() {
    var code = await getCountryFromIpWhoIs();
    if (code) return code;

    code = await getCountryFromIpApi();
    if (code) return code;

    code = getCountryFromShopifySelector();
    if (code) return code;

    return '';
  }

  var countryCode = await getBestCountryCode();
  var marketKey = mapCountryToMarket(countryCode);

  blocks.forEach(function (block) {
    var configEl = block.querySelector('.product-info-gwp-offer__config');
    if (!configEl) {
      block.classList.remove('product-info-gwp-offer--pending');
      return;
    }

    var config = null;

    try {
      config = JSON.parse(configEl.textContent);
    } catch (error) {
      console.warn('Offer by country config parse failed:', error);
      block.classList.remove('product-info-gwp-offer--pending');
      return;
    }

    var markets = config && config.markets ? config.markets : {};
    var displayedMarketKey = getDisplayedMarketKey(markets, marketKey);
    var marketData = pickMarket(markets, marketKey);
    applyOffer(block, marketData, displayedMarketKey);
  });
});